export enum DefaultBoardCreationState {
    NotStarted = 'NotStarted',
    Creating = 'Creating',
    SuccessCreateNew = 'SuccessCreateNew',
    ErrorCreateNew = 'ErrorCreateNew',
}
